<<template>
    <div>
        <feather type="eye" v-if="value === 'text'" class="" @click="changeValue('password')"></feather>
		<feather type="eye-off" v-if="value === 'password'" class="" @click="changeValue('text')"></feather>
    </div>
</template>

<script>
export default {
    name:'password-icon',
    props:['value'],
    methods:{
        changeValue: function(val){
            this.$emit("input", val)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/password_icon.vue